import apiClient from './Api';
const PREFIX = '/import';

const getTreeData = postData => {
  return apiClient({
    url: `${PREFIX}/getnode`,
    method: 'POST',
    data: postData
  });
};

const getMergeTwoVehInfo = postData => {
  return apiClient({
    url: `${PREFIX}/getmergetwovehinfo`,
    method: 'POST',
    data: postData
  });
};

const getFirstData = postData => {
  return apiClient({
    url: `${PREFIX}/getfirst`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE
const download = params => {
  return apiClient({
    url: `${PREFIX}/download?${params}`,
    method: 'GET',
    responseType: 'blob'
  });
};
*/

const deletePhoto = postData => {
  return apiClient({
    url: `${PREFIX}/delete`,
    method: 'POST',
    data: postData
  });
};

const deleteSingleImage = postData => {
  return apiClient({
    url: `${PREFIX}/deletesingle`,
    method: 'POST',
    data: postData
  });
};

const moveTo = postData => {
  return apiClient({
    url: `${PREFIX}/movevehicle`,
    method: 'POST',
    data: postData
  });
};

const renameTo = postData => {
  return apiClient({
    url: `${PREFIX}/renamevehicle`,
    method: 'POST',
    data: postData
  });
};

const swapVin = postData => {
  return apiClient({
    url: `${PREFIX}/swapvin`,
    method: 'POST',
    data: postData
  });
};

const sendImportReport = postData => {
  return apiClient({
    url: `${PREFIX}/report`,
    method: 'POST',
    data: postData
  });
};

const mergeTwoVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/mergeveh`,
    method: 'POST',
    data: postData
  });
};

const sendImportGroupReport = postData => {
  return apiClient({
    url: `${PREFIX}/groupreport`,
    method: 'POST',
    data: postData
  });
};

const reviewVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/reviewvehicle`,
    method: 'POST',
    data: postData
  });
};

const ImportService = {
  // download,
  sendImportReport,
  swapVin,
  renameTo,
  getTreeData,
  getFirstData,
  deletePhoto,
  deleteSingleImage,
  moveTo,
  mergeTwoVehicle,
  sendImportGroupReport,
  getMergeTwoVehInfo,
  reviewVehicle
};

export default ImportService;
